import api from '../axios'

/**
 * @description 认证模块 API 集合
 */
export const authApi = {
  /**
   * @description 用户登录
   * @param {string} email - 用户邮箱
   * @param {string} password - 用户密码
   * @returns {Promise<Object>} 登录响应
   */
  login: (email, password) =>
    api.post('/auth/login', {
      email,
      password,
    }),

  /**
   * @description 用户注册
   * @param {Object} userData - 用户注册数据
   * @returns {Promise<Object>} 注册响应
   */
  register: (userData) => api.post('/auth/register', userData),

  /**
   * @description 用户登出
   * @returns {Promise<Object>} 登出响应
   */
  logout: () => api.post('/auth/logout'),

  /**
   * @description 深圳接口-获取当前登录用户信息
   * @returns {Promise<Object>} 用户信息
   */
  /**
   * TDC 迁移：改调 /store/user/info（mall4j /p/shopapi/v1/userInfo 未迁移）。
   * 后端 VO 字段名已对齐前端契约（agency/agencyLevel/userType/订单计数/nick_name/脱敏 phone）。
   * MVP：暂未含余额/优惠券/方案/收藏/额度等（前端 setUserInfo 对 null/undefined 字段跳过，优雅降级）。
   */
  getUserInfo: () => api.get('/store/user/info', { showError: false }),

  /**
   * @description 厂家授信额度（SAP，与 /store/user/info 解耦）
   * @returns {Promise<Object>} 信贷返回 kyed/klimk，现款返回 balance.available
   */
  getManufacturerQuota: () =>
    api.get('/store/user/manufacturer-quota', {
      showError: false,
      timeout: 30000,
    }),

  /**
   * @description 刷新访问令牌
   * @returns {Promise<Object>} 新令牌响应
   */
  refreshToken: () => api.post('/auth/refresh'),
}
